import ga4 from "../lib/ga-helper";

$(() => {
    //loop through all links and find the text 'join', 'switch' and 'find out more'.
    // Add the associated tracking for each link item.
    $("a").each(function (i, el) {
        const $linkEl = $(el),
            linkText = $linkEl.text().toLowerCase();
        if (linkText.includes("join")) {
            $linkEl.on("click", () => {
                ga4.trackEvnt("campaign_page", {
                    conversion_type: "Join - Campaign page",
                    link_text: $linkEl.text(),
                    link_url: $linkEl.attr("href"),
                });
            });
        } else if (linkText.includes("switch")) {
            $linkEl.on("click", () => {
                ga4.trackEvnt("campaign_page", {
                    conversion_type: "Switch - Campaign page",
                    link_text: $linkEl.text(),
                    link_url: $linkEl.attr("href"),
                });
            });
        } else if (linkText.includes("find out more")) {
            $linkEl.on("click", () => {
                ga4.trackEvnt("campaign_page", {
                    conversion_type: "Find out more - Campaign page",
                    link_text: $linkEl.text(),
                    link_url: $linkEl.attr("href"),
                });
            });
        } else if (linkText.includes("learn more")) {
            $linkEl.on("click", () => {
                ga4.trackEvnt("campaign_page", {
                    user_leads: "Learn more - Campaign page",
                    link_text: $linkEl.text(),
                    link_url: $linkEl.attr("href"),
                });
            });
        } 
    });
    const mHeigths = [
        ".js-callout-with-info-modules-block__subtitle, .js-cards-block-card-section",
    ];
    $.each(mHeigths, function (i, selector) {
        $(selector).matchHeight({
            property: "height",
        });
    });

    class ScrollTo {
        constructor(headerTargetIdName) {
            this.pageHeader = document.getElementById(headerTargetIdName);
            this.resizeTimer;
            this.getHeaderOffset();
            this.$scrollSections = $(".js-scroll-to-section");

            window.addEventListener("resize", () => {
                clearTimeout(this.resizeTimer);
                this.resizeTimer = setTimeout(() => {
                    this.getHeaderOffset();
                }, 500);
            });
            this.$scrollSections.each((id, section) => {
                const $section = $(section);
                $(window).on("scroll", () => {
                    let timer;
                    clearTimeout(timer);
                    timer = setTimeout(() => {
                        if (
                            this.isOnScreen($section) &&
                            $section.hasClass("in-view") === false
                        ) {
                            this.$scrollSections.removeClass("in-view");
                            $section.addClass("in-view");
                            $(".js-main-nav a.scroll-to-trigger").removeClass(
                                "active"
                            );
                            $(".js-main-nav a.scroll-to-trigger").each(
                                (i, link) => {
                                    if (
                                        $(link)
                                            .attr("href")
                                            .includes($section.attr("id"))
                                    ) {
                                        $(link).addClass("active");
                                    }
                                }
                            );
                        }
                    }, 500);
                });
            });

            $(".js-main-nav").on("click", "a.scroll-to-trigger", (ev) => {
                ev.preventDefault();
                const $targetElement = $(ev.target.hash);
                this.scrollToTop($targetElement);
            });
        }
        getHeaderOffset() {
            this.headerOffset = this.pageHeader
                ? this.pageHeader.getBoundingClientRect().height + 30
                : 100;
        }
        scrollToTop(target) {
            const topOffset =
                target[0].getBoundingClientRect().top -
                document.body.getBoundingClientRect().top -
                this.headerOffset;
            window.scrollTo({ behavior: "smooth", top: topOffset });
        }
        isOnScreen($element) {
            const hT = $element.offset().top,
                hH = $element.outerHeight(),
                wH = $(window).height(),
                dS = $(document).scrollTop(),
                elementTopOffset = hT + hH - wH < 0 ? 0 : hT + hH - wH;
            // console.log('offset: ', elementTopOffset, {$element})
            return dS > elementTopOffset && dS < hT + hH ? true : false;
        }
    }

    const $scrollSections = $(".js-scroll-to-section"),
        $navLinksContainers = $(".js-main-nav");
    let menuMarkup = "";
    $scrollSections.each((id, el) => {
        const menuTargetName = $(el).data("menuTargetName");
        if (menuTargetName) {
            menuMarkup += `
      <li>
        <a href="#${$(el).attr("id")}" class="scroll-to-trigger ${
                id === 0 ? "active" : ""
            }">${menuTargetName}</a>
      </li>`;
        }
    });
    $navLinksContainers.prepend(menuMarkup);

    new ScrollTo("js-flexible-container-campaign-header");

    $(".js-back-to-top").on("click", function () {
        window.scrollTo({ behavior: "smooth", top: 0 });
    });
});
